import TransactionSuccess from "./TransactionSuccess";

export default TransactionSuccess;
